export default function users(state = {}, action) {
  switch (action.type) {
    case "show":
      return state;
    default:
      return state;
  }
}
